import React, {useEffect, useRef, useState} from 'react';

import Box from "@mui/material/Box";
import { InputLabel, Select, Stack, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {useForm} from "react-hook-form";


import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {
    getTerritories, getMarkets,
    getLicensees,

} from "./LicenseClient";
import {changeLicense} from "./licenseSlice";
import {changeLicenseSearch} from "./licenseSearchSlice";
import FormDatePicker from "../../CommonComponents/FormDatePicker";
import CircularProgressOverlay from "../../CommonComponents/CircularProgressOverlay";




export default function LicenseSearch({gridClear}) {

    const selectorSubmitting = useSelector((state) => state.externalDataSlc.value.submitting);

    const { register, handleSubmit, control, setValue, reset } = useForm();
    // const {register, handleSubmit} = useForm();
    const [licenseeDropdown, setLicenseeDropdown] = useState([]);
    const [selectedLicensee, setSelectedLicensee] = useState('');
    const [marketDropdown, setMarketDropdown] = useState([]);
    const [selectedMarket, setSelectedMarket] = useState('');
    const [territoryDropdown, setTerritoryDropdown] = useState([]);
    const [selectedTerritory, setSelectedTerritory] = useState('');
    const [productionTypeDropdown, setProductionTypeDropdown] = useState([]);
    const [selectedProductionType, setSelectedProductionType] = useState([]);
    const [producerDropdown, setProducerDropdown] = useState([]);
    const [selectedProducer, setSelectedProducer] = useState([]);
    const [financialCodeDropdown, setFinancialCodeDropdown] = useState([]);
    const [selectedFinancialCode, setSelectedFinancialCode] = useState([]);
    const setupsDropdown = ["","Has","None"];
    const [selectedParticipations, setSelectedParticipations] = useState([]);
    const [selectedResiduals, setSelectedResiduals] = useState([]);
    const [selectedRoyalties, setSelectedRoyalties] = useState([]);
    const [r2mDropdown, setR2mDropdown] = useState([]);
    const [licenseValue, setLicenseValue] = useState([]);
    const [guildValue, setGuildValue] = useState([]);
    const [r2mValue, setR2mValue] = useState([]);
    const dispatchData = useDispatch();
    const [licenses, setLicenses] = useState([]);

    const handleClearClick = () => {
        setLicenseValue("");
    };

    const handleClearLicenseClick = () => {
        setLicenseValue("");
    };

    const fetchLicensees = () =>
        getLicensees()

            .then(data => {
                console.log("M4Mkt Groups");
                console.log(data);
                console.log("M4Mkt Groups with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setLicenseeDropdown(data);
            })


    const fetchMarkets = () => {
        getMarkets()

            .then(data => {
                console.log("Initial Markets");
                console.log(data);
                console.log("Initial Markets with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setMarketDropdown(data);
            })}


    const fetchTerritories = () =>
        getTerritories()

            .then(data => {
                console.log("Territories");
                console.log(data);
                console.log("Territories with empty string");
                data.unshift({singleField: ''});
                console.log(data);
                setTerritoryDropdown(data);
            })


    useEffect(() => {
        console.log("This is for the M4mkt Group dropdown...");
        fetchLicensees();
        fetchMarkets();
        fetchTerritories();

    }, []);


    function onSubmit(data) {
        console.log("here's my license search data before I submit it ")
        console.log({data});
        dispatchData(changeLicenseSearch({
            propertyId: data.propertyId,
            productName: data.productName,
            episodeName: data.episodeName,
            photoStartDateFrom: data.photoStartDateFrom,
            photoStartDateTo: data.photoStartDateTo,
            seriesExternalId: data.seriesExternalId,
            seriesName: data.seriesName,
            seasonExternalId: data.seasonExternalId,
            seasonNumberFrom: data.seasonNumberFrom,
            seasonNumberTo: data.seasonNumberTo,
            seasonName: data.seasonName,
            licensee: data.licensee,
            id: data.id,
            externalId: data.externalId,
            amountFrom: data.amountFrom,
            amountTo: data.amountTo,
            availBeginFrom: data.availBeginFrom,
            availBeginTo: data.availBeginTo,
            availEndFrom: data.availEndFrom,
            availEndTo: data.availEndTo,
            executionDateFrom: data.executionDateFrom,
            executionDateTo: data.executionDateTo,
            market: data.market,
            territory: data.territory,
            participations: data.participations,
            residuals: data.residuals,
            royalties: data.royalties
        }));
        dispatchData(changeLicense({
            licenseGridRefresh: true
        }));
    };


    const handleClear = () => {

        reset({
            propertyId: '',
            productName: '',
            episodeName: '',
            photoStartDateFrom: '',
            photoStartDateTo: '',
            seriesExternalId: '',
            seriesName: '',
            seasonExternalId: '',
            seasonNumberFrom: '',
            seasonNumberTo: '',
            seasonName: '',
            licensee: '',
            id: '',
            externalId: '',
            amountFrom: '',
            amountTo: '',
            availBeginFrom: '',
            availBeginTo: '',
            availEndFrom: '',
            availEndTo: '',
            executionDateFrom: '',
            executionDateTo: '',
            market: '',
            territory: '',
        });

        setSelectedLicensee('');
        setSelectedMarket('');
        setSelectedTerritory('');

        gridClear()

    };

    const handleLicenseeChange = (licenseeEvent) => {
        setSelectedLicensee(licenseeEvent.target.value);
        console.log("This is for the selected Value");
        console.log(licenseeEvent.target.value);
    };

    const handleMarketChange = (marketEvent) => {
        setSelectedMarket(marketEvent.target.value);
        console.log("This is for the selected Value");
        console.log(marketEvent.target.value);
    };

    const handleTerritoryChange = (territoryEvent) => {
        setSelectedTerritory(territoryEvent.target.value);
        console.log("This is for the selected Value");
        console.log(territoryEvent.target.value);
    };

    const handleParticipationsChange = (participationsEvent) => {
        setSelectedParticipations(participationsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(participationsEvent.target.value);
    };

    const handleResidualsChange = (residualsEvent) => {
        setSelectedResiduals(residualsEvent.target.value);
        console.log("This is for the selected Value");
        console.log(residualsEvent.target.value);
    };

    const handleRoyaltiesChange = (royaltiesEvent) => {
        setSelectedRoyalties(royaltiesEvent.target.value);
        console.log("This is for the selected Value");
        console.log(royaltiesEvent.target.value);
    };
    const handleClearLicensee = () => {
        setSelectedLicensee("");}


    const selectR2mRef = useRef();

    const onClear = () => {
    };

    const searchForm  = () => (
        <form
            onSubmit={handleSubmit((data)=>        onSubmit(data))}
        >
            <Box
                sx={{  height: 350, pl: 5}}
                role="presentation"
            >
                <Stack direction={"Horizontal"}  sx={{ pb: 1 }}>

                    <TextField variant="filled"
                               {...register('id', { required: false })}
                               id="id"   name="id"  label="ID" aria-describedby="id_entry"
                               sx={{ width: 100, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('externalId', { required: false })}
                               id="externalId"   name="externalId"  label="External ID" aria-describedby="externalId_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <FormControl variant="standard" sx={{ ml: 1, pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="licensee">Licensee</InputLabel>
                        <Select
                            {...register('licensee', { required: false })}
                            labelId="demo-simple-select-filled-licensee"
                            id="licensee"
                            FreeSolo={true}
                            variant="filled"
                            label="licensee"
                            value={selectedLicensee}
                            onChange={handleLicenseeChange}
                            sx={{ width: 200}}
                        >
                            {licenseeDropdown.map((licenseeItem) =>
                                <MenuItem  FreeSolo={true} value={licenseeItem.singleField} key={licenseeItem.singleField}
                                >{licenseeItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 300 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="market">Market</InputLabel>
                        <Select
                            {...register('market', { required: false })}
                            labelId="demo-simple-select-filled-market"
                            id="market"
                            FreeSolo={true}
                            variant="filled"
                            label="market"
                            value={selectedMarket}
                            onChange={handleMarketChange}
                            sx={{ width: 300}}
                        >
                            {marketDropdown.map((marketItem) =>
                                <MenuItem  FreeSolo={true} value={marketItem.singleField} key={marketItem.singleField}
                                >{marketItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>

                    <FormControl variant="standard" sx={{ pr: 5, minWidth: 200 }} >
                        <InputLabel sx={{ ml: 1}} htmlFor="territory">Territory</InputLabel>
                        <Select
                            {...register('territory', { required: false })}
                            labelId="demo-simple-select-filled-territory"
                            id="territory"
                            FreeSolo={true}
                            variant="filled"
                            label="territory"
                            value={selectedTerritory}
                            onChange={handleTerritoryChange}
                            sx={{ width: 200}}
                        >
                            {territoryDropdown.map((territoryItem) =>
                                <MenuItem  FreeSolo={true} value={territoryItem.singleField} key={territoryItem.singleField}
                                >{territoryItem.singleField}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <TextField variant="filled"
                               {...register('amountFrom', { required: false })}
                               id="amountFrom"   name="amountFrom"  label="Amount From" aria-describedby="amountFrom_entry"
                               sx={{ width: 180, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('amountTo', { required: false })}
                               id="amountTo"   name="amountTo"  label="Amount To" aria-describedby="amountTo_entry"
                               sx={{ width: 180, pr: 5 }} />
                </Stack>
                <Stack direction={"Horizontal"} sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('propertyId', { required: false })}
                               id="propertyId"   name="propertyId"  label="Property ID" aria-describedby="propertyId_entry"
                               sx={{ width: 150, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('productName', { required: false })}
                               id="productName"   name="productName"  label="Product Name" aria-describedby="productName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    {/*<FormHelperText id="name_helper">enter the name of the Data Point</FormHelperText>*/}
                    <TextField variant="filled"
                               {...register('episodeName', { required: false })}
                               id="episodeName"   name="episodeName"  label="Episode Name" aria-describedby="episodeName_entry"
                               sx={{ width: 400, pr: 5  }} />
                    <FormDatePicker
                        name="photoStartDateFrom"
                        label="Photo From"
                        control={control}
                        width={200}
                    />
                    <FormDatePicker
                        name="photoStartDateTo"
                        label="Photo To"
                        control={control}
                        width={200}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateFrom', { required: false })}*/}
                    {/*           id="photoStartDateFrom"   name="photoStartDateFrom"  label="Photo From" aria-describedby="photoStartDateFrom_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('photoStartDateTo', { required: false })}*/}
                    {/*           id="photoStartDateTo"   name="photoStartDateTo"  label="Photo To" aria-describedby="photoStartDateTo_entry"*/}
                    {/*           sx={{ width: 150, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"horizontal"}  sx={{ pb: 1 }}>
                    <TextField variant="filled"
                               {...register('seriesExternalId', { required: false })}
                               id="seriesExternalId"   name="seriesExternalId"  label="Series ID" aria-describedby="seriesExternalId_entry"
                               sx={{ width:160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seriesName', { required: false })}
                               id="seriesName"   name="seriesName"  label="Series Name" aria-describedby="seriesName_entry"
                               sx={{ width: 400, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonExternalId', { required: false })}
                               id="seasonExternalId"   name="seasonExternalId"  label="Season ID" aria-describedby="seasonExternalId_entry"
                               sx={{ width: 160, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberFrom', { required: false })}
                               id="seasonNumberFrom"   name="seasonNumberFrom"  label="# From" aria-describedby="seasonNumberFrom_entry"
                               sx={{ width: 140, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonNumberTo', { required: false })}
                               id="seasonNumberTo"   name="seasonNumberTo"  label="# To" aria-describedby="seasonNumberTo_entry"
                               sx={{ width: 140, pr: 5 }} />
                    <TextField variant="filled"
                               {...register('seasonName', { required: false })}
                               id="seasonName"   name="seasonName"  label="Season Name" aria-describedby="seasonName_entry"
                               sx={{ width: 400 }} />
                </Stack>

                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>
                    <FormDatePicker
                        name="availBeginFrom"
                        label="Avail Begin From"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="availBeginTo"
                        label="Avail Begin To"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="availEndFrom"
                        label="Avail End From"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="availEndTo"
                        label="Avail End To"
                        control={control}
                        width={220}
                    />
                    <FormDatePicker
                        name="executionDateFrom"
                        label="Execution Date From"
                        control={control}
                        width={240}
                    />
                    <FormDatePicker
                        name="executionDateTo"
                        label="Execution Date To"
                        control={control}
                        width={240}
                    />
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('availBeginFrom', { required: false })}*/}
                    {/*           id="availBeginFrom"   name="availBeginFrom"  label="Avail Begin From" aria-describedby="availBeginFrom_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('availBeginTo', { required: false })}*/}
                    {/*           id="availBeginTo"   name="availBeginTo"  label="Avail Begin To" aria-describedby="availBeginTo_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('availEndFrom', { required: false })}*/}
                    {/*           id="availEndFrom"   name="availEndFrom"  label="Avail End From" aria-describedby="availEndFrom_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('availEndTo', { required: false })}*/}
                    {/*           id="availEndTo"   name="availEndTo"  label="Avail End To" aria-describedby="availEndTo_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('executionDateFrom', { required: false })}*/}
                    {/*           id="executionDateFrom"   name="executionDateFrom"  label="Execution Date From" aria-describedby="executionDateFrom_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                    {/*<TextField variant="filled"*/}
                    {/*           {...register('executionDateTo', { required: false })}*/}
                    {/*           id="executionDateTo"   name="executionDateTo"  label="Execution Date To" aria-describedby="executionDateTo_entry"*/}
                    {/*           sx={{ width: 200, pr: 5 }} />*/}
                </Stack>
                <Stack direction={"Horizontal"}  sx={{ pb: 2 }}>

                    <Button
                        type= "submit"
                    >RETRIEVE</Button>
                    <Button onClick={handleClear}
                    >CLEAR</Button>
                </Stack>
            </Box>
        </form>
    );

    return (
        <Box sx={{ position: 'relative' }}>
            {searchForm()}
            {selectorSubmitting && <CircularProgressOverlay/>}
        </Box>

    )

}

